import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import './RichTextBlock.scss';
export function RichTextContent({ html }) {
    return React.createElement(RawHTML, { className: 'content-block-rich-text', html: html });
}
export function RichTextBlock({ data }) {
    return React.createElement(RichTextContent, { html: data.value });
}
